import React from "react";

export const carouselDefaultConfig = {
	dots: true,
	slidesToShow: 3.3,
	slidesToScroll:1,
	draggable: true,
	className: "slider",
  	dotsClass: "dots",
	arrows:true,
	centerMode:false,
	infinite:false,
	responsive: [
		{
			breakpoint: 1024,
			settings: {
				slidesToShow: 2.08,
				slidesToScroll: 1,
			},
		},
		{
			breakpoint: 767,
			settings: {
				slidesToShow: 1,
				slidesToScroll: 1,
				arrows: false,
			},
		},
	],
};
